import { render } from "./bmsTest.vue?vue&type=template&id=5c66c266&scoped=true"
import script from "./bmsTest.vue?vue&type=script&lang=js"
export * from "./bmsTest.vue?vue&type=script&lang=js"

import "./bmsTest.vue?vue&type=style&index=0&id=5c66c266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c66c266"]])

export default __exports__